module.exports = "<div scope=\"public_profile,email\"\r\n     class=\"fb-login-button\" data-max-rows=\"1\" data-size=\"large\"\r\n     data-button-type=\"continue_with\" data-show-faces=\"false\"\r\n     data-auto-logout-link=\"false\" data-use-continue-as=\"false\">\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/auth/auth-form/auth-facebook.component.html
// module id = 831
// module chunks = 0